import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { Form, Row, Button } from 'antd'
import { Map } from 'immutable'

import ProductCategorySelector from '../../../../components/productCategorySelector'

import inquiryActions from '../../../../redux/inquiry/actions'

const { saveOrderForm } = inquiryActions

const CategoryForm = ({
  productCategory,
  orderId,
  onSuccess,
  onCancel
}) => {
  const { i18n } = useTranslation('orders')
  const dispatch = useDispatch()
  const saving = useSelector(state => state.getIn(['inquiry', 'saveOrderLoading']))

  const onSubmitForm = (values) => {
    dispatch(saveOrderForm(orderId, values, {
      onSuccess: () => { onSuccess() }
    }))
  }

  const productCategoryId = productCategory.get('id')

  return (
    <Form onFinish={onSubmitForm}>
        <div>
            <label className="title">{i18n.t('orders:productCategory')} :</label>
              <Form.Item
                name='product_category_id'
                initialValue={productCategoryId ? `${productCategoryId}` : null}>
                <ProductCategorySelector
                  defaultProductCategory={{ name: productCategory.get('name') }}
                  placeholder={i18n.t('orders:selectCategory')}
                  style={{ width: '80%' }} />
              </Form.Item>
            <Row className="btn-center">
                <Button style={{ width: 60, marginRight: '8px' }}
                    type="primary"
                    size="small"
                    htmlType="submit"
                    loading={saving}>{i18n.t('inquiries:edit')}</Button>
                <Button style={{ width: 60 }}
                    size="small"
                    disabled={saving}
                    onClick={onCancel}> {i18n.t('inquiries:cancel')}</Button>
            </Row>
        </div>
    </Form>
  )
}

CategoryForm.propTypes = {
  productCategory: PropTypes.object,
  orderId: PropTypes.string,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func
}

CategoryForm.defaultProps = {
  productCategory: new Map(),
  onSuccess: () => {},
  onCancel: () => {}
}

export default CategoryForm
